import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Text } from 'components/text'
import { LinkButton } from 'components/buttons'
import { selectIsLangEnglish } from 'modules/language/selectors'
import { createStructuredSelector } from 'reselect'
import { selectRenewalOffer } from 'pages/Renewal/selectors'
import { selectLatestProduct } from 'pages/Account/selectors'

import {
  PlusSection,
  PlusSectionDescription,
  PlusDescription,
} from './styled'

import { color } from 'styles/variables'

const PlusBanner = ({
  setBannerHeight,
  isEnglish,
}) => {

  const ref = useRef(null)
  useEffect(() => {
    const getDynamicBannerHeight = () => {
      if (ref.current) {
        const style = getComputedStyle(ref.current)
        const height =
          ref.current.offsetHeight +
          parseInt(style.marginTop) +
          parseInt(style.marginBottom) +
          parseInt(style.paddingTop) +
          parseInt(style.paddingBottom)

        setBannerHeight(height)
      }
    }

    getDynamicBannerHeight()

    window.addEventListener('resize', getDynamicBannerHeight)

    return () => {
      window.removeEventListener('resize', getDynamicBannerHeight)
    }
  }, [ref])



  return (
    <div ref={ref}>
      {
        color.plusBanner &&
        color.plusBanner.bannerTextEn &&
        color.plusBanner.bannerTextEs &&
        <PlusSection>
          <PlusSectionDescription>
            <PlusDescription>
              <Text width='100%' color='white'>
                {isEnglish ? color.plusBanner.bannerTextEn : color.plusBanner.bannerTextEs}{' '}
                <LinkButton href={color.plusBanner.bannerUrl} color='white'>
                  {isEnglish ? 'Click here' : 'Haz clic aquí'}
                </LinkButton>
              </Text>
            </PlusDescription>
          </PlusSectionDescription>
        </PlusSection>
      }
    </div>
  )
}

PlusBanner.propTypes = {
  isEnglish: PropTypes.bool.isRequired,
  latestProduct: PropTypes.object,
  renewal: PropTypes.object,
}

const mapStateToProps = createStructuredSelector({
  isEnglish: selectIsLangEnglish,
  latestProduct: selectLatestProduct,
  renewal: selectRenewalOffer,
})


export default connect(mapStateToProps)(PlusBanner)
